// Decoders
import createShape from 'fc-decoder-shape'
import category from './category'

// Constants
import {
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

import {
  PROP_ASSET_ID,
  PROP_CATEGORY,
} from 'fc-model-assets'

// Exports
export default function decodeShape (maybeShape, asset) {
  const shape = (maybeShape && createShape(maybeShape)) || null

  if (shape && shape[PROP_SHAPE_DATA]) {
    return {
      ...shape,
      [PROP_SHAPE_DATA]: {
        ...shape[PROP_SHAPE_DATA],
        properties: {
          ...shape[PROP_SHAPE_DATA].properties,
          id: asset[PROP_ASSET_ID],
          category: category(asset[PROP_CATEGORY]),
        },
      },
    }
  }

  return shape
}
